export default "__VITE_ASSET__lJaLA8eM__"